import {AppUtils} from "@app/shared/util/app.utils";

export class StrainImageModel {
    public id: number;
    public name: string;
    public data: string;
    public extension: string;
    public contentType: string;
    public url: string;

    constructor(entry: any = {}) {
        this.id = entry.id;
        this.name = entry.name;
        this.data = entry.data;
        this.extension = entry.extension;
        this.contentType = entry.contentType;
        this.url = entry.data ? this.computeImageUrl(entry.data) : entry.url || null;
    }

    computeImageUrl(data) {
        const blob = AppUtils.buildBlobFromDataString(data);
        return URL.createObjectURL(blob);
    }
}
